import NotFound from "./NotFound.view";

export default NotFound;
